import produce from "immer";
import { create } from "zustand";
import { DEFAULT_FILTERS } from "../constants";

export const usePilotageRhStore = create((set) => ({
    /* period: clé API ; agency_id / manager_id : ids ou null (= tous) ;
       department : nom (liste en dur) ou null */
    filters: { ...DEFAULT_FILTERS },
    /* map sectionId -> bool : comparaison "vs précédent" activée */
    compare: {},

    setFilter: (key, value) =>
        set(
            produce((state) => {
                state.filters[key] = value;
            })
        ),
    resetFilters: () =>
        set(
            produce((state) => {
                state.filters = { ...DEFAULT_FILTERS };
            })
        ),
    toggleCompare: (sectionId) =>
        set(
            produce((state) => {
                state.compare[sectionId] = !state.compare[sectionId];
            })
        ),
}));
